(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["flavour-showcase"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initShowcase(root) {
      var track = root.querySelector('[data-track]');
      var slides = Array.prototype.slice.call(root.querySelectorAll('[data-slide]'));
      var prevBtn = root.querySelector('[data-prev]');
      var nextBtn = root.querySelector('[data-next]');
      var detailTag = root.querySelector('[data-detail-tag]');
      var detailName = root.querySelector('[data-detail-name]');
      var detailDesc = root.querySelector('[data-detail-desc]');
      var detailCta = root.querySelector('[data-detail-cta]');

      if (!track || slides.length === 0) return;

      function setActive(slide) {
        slides.forEach(function (s) {
          s.classList.toggle('is-active', s === slide);
        });
        document.documentElement.style.setProperty('--site-border-color', slide.dataset.color || 'transparent');
        if (detailTag) {
          detailTag.textContent = slide.dataset.tag || '';
          detailTag.style.color = slide.dataset.color || '';
        }
        if (detailName) detailName.textContent = slide.dataset.name || '';
        if (detailDesc) detailDesc.textContent = slide.dataset.desc || '';
        if (detailCta) {
          var link = slide.dataset.link || '';
          if (link) {
            detailCta.href = link;
            detailCta.textContent = 'Shop Now';
            detailCta.classList.remove('flavour-showcase__detail-cta--soon');
          } else {
            detailCta.removeAttribute('href');
            detailCta.textContent = 'Coming Soon';
            detailCta.classList.add('flavour-showcase__detail-cta--soon');
          }
        }
      }

      function scrollToSlide(slide, instant) {
        slide.scrollIntoView({
          behavior: instant ? 'auto' : 'smooth',
          inline: 'center',
          block: 'nearest'
        });
      }

      var observer = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting) {
              setActive(entry.target);
            }
          });
        },
        { root: track, threshold: 0.6, rootMargin: '0px -35% 0px -35%' }
      );

      slides.forEach(function (slide) {
        observer.observe(slide);
        slide.addEventListener('click', function () {
          scrollToSlide(slide, false);
        });
      });

      function currentIndex() {
        var found = 0;
        slides.forEach(function (s, i) {
          if (s.classList.contains('is-active')) found = i;
        });
        return found;
      }

      if (prevBtn) {
        prevBtn.addEventListener('click', function () {
          var i = currentIndex();
          var nextIdx = (i - 1 + slides.length) % slides.length;
          scrollToSlide(slides[nextIdx], false);
        });
      }
      if (nextBtn) {
        nextBtn.addEventListener('click', function () {
          var i = currentIndex();
          var nextIdx = (i + 1) % slides.length;
          scrollToSlide(slides[nextIdx], false);
        });
      }

      var defaultSlide = root.querySelector('[data-default-active]') || slides[0];
      setActive(defaultSlide);
      scrollToSlide(defaultSlide, true);
    }

    document.querySelectorAll('[data-flavour-showcase]').forEach(initShowcase);

    window.addEventListener('beforeunload', function () {
      document.documentElement.style.removeProperty('--site-border-color');
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
